var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loaded
    ? _c(
        "ul",
        {
          class: [
            { "file-tree": typeof _vm.collections === "string" },
            "collection-group",
          ],
        },
        [
          _vm._l(_vm.collectionTree, function (collection) {
            return _c(
              "li",
              {
                key: collection.id,
                class:
                  typeof _vm.collections === "string"
                    ? "parent-node"
                    : "tree-node",
              },
              [
                _c(
                  "span",
                  {
                    class: [
                      "folder",
                      { "empty-collection": !collection.children.length },
                      { collapsible: collection.children.length },
                    ],
                    on: {
                      click: function ($event) {
                        return _vm.collapse(collection)
                      },
                    },
                  },
                  [
                    !collection.children.length && !collection.metadata.length
                      ? _c("i", {
                          staticClass: "far fa-folder",
                          attrs: {
                            "data-bs-toggle": "tooltip",
                            "data-bs-placement": "top",
                            title:
                              "This collection doesn't have sub-collections and metadata",
                          },
                        })
                      : !collection.children.length &&
                        collection.metadata.length
                      ? _c("i", {
                          staticClass: "fas fa-folder",
                          attrs: {
                            "data-bs-toggle": "tooltip",
                            "data-bs-placement": "top",
                            title: "This collection has metadata",
                          },
                        })
                      : collection.children.length &&
                        !collection.metadata.length &&
                        !collection.isExpanded
                      ? _c("i", {
                          staticClass: "fas fa-folders",
                          attrs: {
                            "data-bs-toggle": "tooltip",
                            "data-bs-placement": "top",
                            title: "This collection has sub-collections",
                          },
                        })
                      : collection.children.length &&
                        !collection.metadata.length &&
                        collection.isExpanded
                      ? _c("i", {
                          staticClass: "fas fa-folder-open",
                          attrs: {
                            "data-bs-toggle": "tooltip",
                            "data-bs-placement": "top",
                            title: "This collection has sub-collections",
                          },
                        })
                      : !collection.isExpanded
                      ? _c("i", {
                          staticClass: "fad fa-folders",
                          attrs: {
                            "data-bs-toggle": "tooltip",
                            "data-bs-placement": "top",
                            title:
                              "This collection has sub-collections and metadata",
                          },
                        })
                      : _c("i", {
                          staticClass: "fad fa-folder-open",
                          attrs: {
                            "data-bs-toggle": "tooltip",
                            "data-bs-placement": "top",
                            title:
                              "This collection has sub-collections and metadata",
                          },
                        }),
                  ]
                ),
                _vm._v(" "),
                !collection.isSelected
                  ? _c("span", [
                      _c(
                        "a",
                        {
                          attrs: { href: _vm.getCollectionUrl(collection.id) },
                        },
                        [_vm._v(_vm._s(collection.title))]
                      ),
                    ])
                  : _c("span", [
                      _vm._v(
                        "\n            " +
                          _vm._s(collection.title) +
                          "\n        "
                      ),
                    ]),
                _vm._v(" "),
                collection.children.length && collection.isExpanded
                  ? _c(
                      "span",
                      [
                        _c("collection", {
                          attrs: {
                            collections: collection.children,
                            "selected-collection": _vm.selectedCollection,
                            "collection-url": _vm.collectionUrl,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            )
          }),
          _vm._v(" "),
          !_vm.collectionTree.length
            ? _c("div", [
                _vm._v(
                  "\n        There's no collection in this organisation.\n    "
                ),
              ])
            : _vm._e(),
        ],
        2
      )
    : _c("Loading")
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }